module.exports = __webpack_public_path__ + "home-block-6-overlay-wide-1dhzTjR.png";